import { defineStore } from "pinia";

export const useAutoPaySectionStore = defineStore('autoPaySection', {
    state: () => ({
        autoPaySection: {},
        autoPaySections: [],
    }),
    actions: {
        setAutoPaySection(autoPaySection) {
            this.autoPaySection = autoPaySection
        },
        setAutoPaySections(autoPaySections) {
            this.autoPaySections = autoPaySections
        },
        addAutoPaySection(autoPaySection) {
            this.autoPaySections.unshift(autoPaySection)
        },
        updateAutoPaySection(autoPaySection) {
            let index = this.autoPaySections.findIndex(cl => cl.id === autoPaySection.id)
            this.autoPaySections.splice(index, 1, autoPaySection)
        },
        deleteAutoPaySection(autoPaySection) {
            let index = this.autoPaySections.findIndex(cl => cl.id === autoPaySection.id)
            this.autoPaySections.splice(index, 1)
        },
    },
});